import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAppStore } from "@/store/appStore";

export const useIsAdmin = () => {
  const session = useAppStore((s) => s.session);
  const userId = session?.user?.id;

  const query = useQuery({
    queryKey: ["is-admin", userId],
    enabled: !!userId,
    staleTime: 60_000,
    queryFn: async () => {
      if (!userId) return false;
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .eq("role", "admin")
        .maybeSingle();
      if (error) return false;
      return !!data;
    },
  });

  return {
    isAdmin: !!query.data,
    // Treat "not yet enabled" (no userId) as still loading so route guards wait.
    isLoading: !!userId && (query.isLoading || query.isFetching),
  };
};
